import * as React from 'react';
import { Button, Box } from '../../components';
import { FieldProps } from 'formik'
import { Label } from '../../typography/'

type ButtonsToRender = {
    label: string;
    value: string;
}
type Props = FieldProps & {
    buttonsToRender: ButtonsToRender[];
    onClicked?: (index: number) => void;
}
function getButtonColour(label: string): string {
    const labelName = 'Easy' ;
    if (label === labelName) {
        return 'white';
    } else {
        return '#d3d3d3'
    }
}

const ButtonCheckBoxGroup: React.FC<Props> = ({ buttonsToRender, onClicked }) => {
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [ButtonColor, setButtonColor] = React.useState(false);
    React.useEffect(() => {
        console.log('clicked')
    }, [selectedIndex, ButtonColor])
    return (
        <Box  flex={1} minWidth={150} alignItems= "flex-start" width= "100%"
        mb={2}
        >
            <Label fontSize={16} >Fitness Level</Label>
            <Box justifyContent="space-between" 
            flexDirection="row" alignItems= "space-between"
             minWidth={150} width="100%">
                {buttonsToRender.map((button: any, index ) => {
                    console.log(index)
                    return (
                        <Button
                            onClick={() => {
                                if (onClicked) {
                                    setSelectedIndex(buttonsToRender.indexOf(button))
                                    setButtonColor(!ButtonColor);
                                    onClicked(selectedIndex)
                                }
                            }}
                            key={button.label}
                            outline={true}
                            bg={ !ButtonColor ? getButtonColour(button.label) : '#d3d3d3'}
                            width="20%"
                            color="black"
                            type="button"
                            border={'4px solid #d3d3d3'}
                            text={button.label}
                        />
                    )
                })}
            </Box>
        </Box>
    )

}

export default ButtonCheckBoxGroup



// WEBPACK FOOTER //
// ./src/components/formElements/ButtonCheckBoxGroup.tsx